export default "__VITE_ASSET__DqlbBLaf__"